import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';

//import { Button, FormControlLabel, MenuItem, Radio, Typography, Icon, IconButton } from 'material-ui';
import { InputLabel, Select as MSelect, Radio, MenuItem, TextField, Checkbox, FormControlLabel, Divider, Button, Paper, Typography, FormControl, FormHelperText, Icon, IconButton } from 'material-ui';

import $ from "jquery";
import ReactTable from "react-table";
import axios from 'axios/index';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import moment from 'moment';
import 'react-select/dist/react-select.css';
import Select from 'react-select';
import 'react-day-picker/lib/style.css';
import { confirmAlert } from 'react-confirm-alert';
import Tooltip from 'material-ui/Tooltip';
import printjs from 'print-js';
import classNames from 'classnames';

const styles = theme => ({
    layoutRoot: {},
    paper: { padding: '10px' },
    input: {
        'margin-top': 0
    }
});

var id = null;
var ID_CHEQUE_BOOK = null;
var chequeId = null;
var update_id = null;
var create_date = null;
var doc_number = null;
var bank_name = null;
var branch_name = null;
var acc_number = null;
var total_pages = null;
var newDateAr = [];
class BankDeposit extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            banks: [],
            bankLedgers: [],
            cheques: [],
            draftList: [],
            depositDetails: [],
            bank: '',
            deposited_bank: '',
            date: moment(new Date()).format("YYYY-MM-DD"),
            transaction_date: moment(new Date()).format("YYYY-MM-DD"),
            from_date: moment(new Date()).format("YYYY-MM-DD"),
            to_date: moment(new Date()).format("YYYY-MM-DD"),
            isActive: true,
            loading: false,
            shown: true,
            search_type: 'CHEQUE',
            doc_num: '',
            ref_no: '',
            description: '',
            cheque_no: '',
            total_cash_amount: '',
            cash_amount: '',
            isUpdate: false,
            dueAmountCheck: false,
            ID_DIPOSIT_HEADER: '',
            cashBookBalance: 0
        };

        this.loadBanks();
        this.loadData();
        this.loadBankLedger();
        this.handleFromDate = this.handleFromDate.bind(this);
        this.handleToDate = this.handleToDate.bind(this);


    }

    loadCashBookBalance() {
        const cashObj = {
            id: 6
        }
        // axios.post('http://localhost:5009/cashBook/loadCashBookBalance', cashObj)
        axios.post(window.accountServer + '/cashBook/loadCashBookBalance', cashObj)
            .then(response => {
                if (response.data.success) {
                    var resObj = response.data.result;
                    console.log(resObj)
                    var total_cash_amount = response.data.result[0].TOTAL_DEBIT_AMOUNT - response.data.result[0].TOTAL_CREDIT_AMOUNT;
                    // alert(total_cash_amount)

                    this.setState({ total_cash_amount: total_cash_amount });
                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    loadData() {
        var resObj;
        // axios.get('http://localhost:5009/deposit/getDepositInDraft')
        axios.get(window.accountServer + '/deposit/getDepositInDraft')
            .then(response => {
                if (response.data.success) {
                    resObj = response.data.depositHeader;
                    console.log(resObj)
                    this.appendToDraftTable(resObj)
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        // this.closeNewCustomerDialog();
    }

    searchReciptData() {
        this.setState({ loading: true });
        var bankName = null;
        if (this.state.bank.label == null) {
            bankName = this.state.bank
        } else {
            bankName = this.state.bank.label;
        }
        // var bankName = this.state.bank.label;
        var fromDate = this.state.from_date;
        var toDate = this.state.to_date;
        var resObj;
        if (bankName == null) {
            this.props.alert.error('select cheque issued bank');
        } else {
            const searchObj = {
                paymentType: "Cheque",
                bankName: bankName,
                fromDate: fromDate,
                toDate: toDate
            }

            console.log(searchObj)
            // axios.post('http://localhost:5006/receipt/getReceiptPaymentDetails', searchObj)
            axios.post(window.salesServer + '/receipt/getReceiptPaymentDetails', searchObj)
                .then(response => {
                    if (response.data.success) {
                        resObj = response.data.result;
                        console.log(resObj)
                        this.setState({ cheques: [] });
                        this.appendToTable(resObj)
                    }


                }).catch(function (error) {
                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        }

    }


    appendToDraftTable(reciptObj) {

        console.log(reciptObj)
        var data = [];
        var active;
        for (let i = 0; i < reciptObj.length; i++) {

            data.push({
                row_id: i,
                id: reciptObj[i].ID_DIPOSIT_HEADER,
                // id: "B-" + checkBookObj[i].ID_LEDGER_ACCOUNT,
                draftCode: reciptObj[i].DOCUMENT_NO,
                date: reciptObj[i].DATE

                // active: active
            });

        }

        this.setState({ draftList: data });
        // this.setState({ loading: false });
    }



    appendToTable(reciptObj) {

        console.log(reciptObj)
        var data = [];
        var active;
        for (let i = 0; i < reciptObj.length; i++) {

            data.push({
                row_id: i,
                id: reciptObj[i].ID_PAYMENT_MODE,
                // id: "B-" + checkBookObj[i].ID_LEDGER_ACCOUNT,
                cheque_date: reciptObj[i].CHEQUE_DATE,
                cheque_no: reciptObj[i].CHEQUE_NO,
                bank: reciptObj[i].BANK_NAME,
                amount: reciptObj[i].AMOUNT,

                // active: active
            });

        }

        this.setState({ cheques: data });
        this.setState({ loading: false });
        if (this.state.isUpdate == true) {
            // alert()
            newDateAr = []
            this.appendToTableDraftDetails(this.state.depositDetails)
        }
        // this.setState({ loading: false });
    }

    appendToTableDraftDetails(reciptObj) {

        console.log(reciptObj)
        var data = [];
        var active;

        for (let i = 0; i < reciptObj.length; i++) {
            this.checkDraft(reciptObj[i].CHEQUE_NO)
        }

        // for (let i = 0; i < reciptObj.length; i++) {

        //     data.push({
        //         row_id: i,
        //         id: reciptObj[i].ID_DIPOSIT_DETAIL_HEADER,
        //         // id: "B-" + checkBookObj[i].ID_LEDGER_ACCOUNT,
        //         cheque_date: reciptObj[i].CHEQUE_DATE,
        //         cheque_no: reciptObj[i].CHEQUE_NO,
        //         bank: reciptObj[i].BANK,
        //         amount: reciptObj[i].AMOUNT,
        //         // dueAmountCheck: true
        //         // active: active
        //     });


        // }

        // this.setState({ loading: false });
    }

    checkDraft(chqueNo) {
        console.log("chqueNo " + chqueNo)
        var newDateArs = this.state.cheques.slice();
        console.log("newDateArs " + JSON.stringify(newDateArs))
        for (let i = 0; i < newDateArs.length; i++) {

            // console.log("chqueNo "+chqueNo)
            if (newDateArs[i].cheque_no == chqueNo) {
                // alert(i+'g'+newDateArs[i].row_id)
                // newDateArs[i].dueAmountCheck = true;
                // newDateArs[1].dueAmountCheck = true;
                this.handleCheckControlAccountDraft(
                    newDateArs[i].row_id,
                    newDateArs[i].id,
                    newDateArs[i].cheque_date,
                    newDateArs[i].cheque_no,
                    newDateArs[i].bank,
                    newDateArs[i].amount,
                )
            }
        }
    }

    handleBank = (selectedOption) => {
        this.setState({
            bank: selectedOption
        });


    }

    handleDepositBank = (selectedOption) => {
        this.setState({
            deposited_bank: selectedOption
        });


    }


    loadDraftDetails = (id) => {
        // alert(id)
        this.setState({ loading: true });
        // this.setState({ accountList: [] });
        // this.setState({ draftId: id });
        // var draftAccountList = [];

        // axios.post('http://localhost:5009/deposit/getDepositInDraftDetailsById', { 'id': id })
        axios.post(window.accountServer + '/deposit/getDepositInDraftDetailsById', { 'id': id })
            .then(response => {

                // console.log(response.data.depositHeader);
                // console.log(response.data.depositDetails);
                this.setState({
                    search_type: response.data.depositHeader[0].DEPOSIT_TYPE,
                    doc_num: response.data.depositHeader[0].DOCUMENT_NO,
                    ref_no: response.data.depositHeader[0].REFERENCE_NO,
                    description: response.data.depositHeader[0].DESCRIPTION,
                    cheque_no: response.data.depositHeader[0].NUM_OF_CHEQUE,
                    total_cash_amount: response.data.depositHeader[0].CASH_TOTAL_AMOUNT,
                    cash_amount: response.data.depositHeader[0].CASH_PAYED_AMOUNT,
                    bank: response.data.depositHeader[0].ISSUED_BANK,
                    deposited_bank: response.data.depositHeader[0].DEPOSIT_LEDGER_ID,
                    date: response.data.depositHeader[0].DATE,
                    transaction_date: response.data.depositHeader[0].TRANSACTION_DATE,
                    from_date: response.data.depositHeader[0].FROM_DATE,
                    to_date: response.data.depositHeader[0].TO_DATE,
                    isUpdate: true,
                    depositDetails: response.data.depositDetails,
                    ID_DIPOSIT_HEADER: id
                })
                this.setState({ cheques: [] });
                if (response.data.depositHeader[0].ISSUED_BANK != null) {
                    // alert()
                    this.searchReciptData()
                } else {
                    this.setState({ loading: false });
                }


                // for (let i = 0; i < response.data.length; i++) {

                //     draftAccountList.push({
                //         index: i,
                //         mainId: 'Draft',
                //         id: response.data[i].ID_LEDGER_ACCOUNT,
                //         name: response.data[i].NAME_LEDGER_ACCOUNT,
                //         type: response.data[i].BALANCE_TYPE,
                //         value: response.data[i].BALANCE_AMOUNT,
                //         isSingle: false
                //     });
                // }
                // this.setState({ loading: false });
                // this.setState({ accountList: draftAccountList });

            }).catch(function (error) {
                console.log("err " + error);
            });
    }


    loadBanks() {
        var banks = [];
        // // axios.get('http://localhost:5009/bank/getBankDetails')
        // axios.get(window.accountServer + '/bank/getBankDetails')
        axios.get(window.systemServer + '/system/loadBanks')
            .then(response => {
                if (window.DATABASE_TYPE == "MYSQL")
                    for (let i = 0; i < response.data.result.length; i++) {

                        banks.push({
                            value: response.data.result[i].bank_name,
                            label: response.data.result[i].bank_name
                        });
                    }
                else
                    for (let i = 0; i < response.data.length; i++) {

                        banks.push({
                            value: response.data[i].bank_name,
                            label: response.data[i].bank_name
                        });
                    }
                this.setState({ banks: banks });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }


    loadBankLedger() {
        var bankLedgers = [];
        // axios.get('http://localhost:5009/ledgerAccount/getBankLedgerAccountDetails')
        axios.get(window.accountServer + '/ledgerAccount/getBankLedgerAccountDetails')
            .then(response => {

                for (let i = 0; i < response.data.bankLedgerDetails.length; i++) {
                    // console.log("rrrr" + JSON.stringify(response.data.bankDetails[i].bank_name));
                    bankLedgers.push({
                        value: response.data.bankLedgerDetails[i].ID_LEDGER_ACCOUNT,
                        label: response.data.bankLedgerDetails[i].NAME
                    });
                }
                this.setState({ bankLedgers: bankLedgers });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }


    handleDescription = (event) => {
        this.setState({
            description: event.target.value
        });
    };

    handleRefNo = (event) => {
        this.setState({
            ref_no: event.target.value
        });
    };

    handleDocNo = (event) => {
        this.setState({
            doc_num: event.target.value
        });
    };
    handleFromDate = (event) => {
        // alert(event.target.value)

        this.setState({
            from_date: event.target.value
        });
    };

    handleToDate = (event) => {
        this.setState({
            to_date: event.target.value
        });
    };

    handleTransactionDate = (event) => {
        this.setState({
            transaction_date: event.target.value
        });
    };

    handleDate = (event) => {
        this.setState({
            date: event.target.value
        });
    };

    handleTotalCashAmount = (event) => {
        this.setState({
            total_cash_amount: event.target.value
        });
    };

    handleCashAmount = (event) => {
        this.setState({
            cash_amount: event.target.value
        });
    };



    handleCheckControlAccountDraft(row_id, data_id, cheque_date, cheque_no, bank, amount) {
        var newDateArs = this.state.cheques.slice();


        newDateAr.push({
            id: data_id,
            row_id: row_id,
            cheque_date: cheque_date,
            cheque_no: cheque_no,
            bank: bank,
            amount: amount
        })
        // alert(row_id)
        newDateArs[row_id].dueAmountCheck = true;
        // $("#checkRecipt_" + data_id).prop('checked',false)


        console.log(JSON.stringify(newDateAr))
        this.setState({
            cheque_no: newDateAr.length
        });

    };



    handleCheckControlAccount(e, row_id, data_id, cheque_date, cheque_no, bank, amount) {
        var newDateArs = this.state.cheques.slice();
        if ($("#checkRecipt_" + data_id).prop('checked') == true) {
            newDateAr.push({
                id: data_id,
                row_id: row_id,
                cheque_date: cheque_date,
                cheque_no: cheque_no,
                bank: bank,
                amount: amount
            })
            // alert(row_id)
            newDateArs[row_id].dueAmountCheck = true;
            // $("#checkRecipt_" + data_id).prop('checked',false)
        } else {
            newDateArs[row_id].dueAmountCheck = false;
            var index = newDateAr.map(function (x) { return x.row_id; }).indexOf(row_id);
            newDateAr.splice(index, 1);
        }

        console.log(JSON.stringify(newDateAr))
        this.setState({
            cheque_no: newDateAr.length
        });

    };

    addToDraft() {
        if (this.state.isUpdate == true) {
            const depositObj = {
                ID_DIPOSIT_HEADER: this.state.ID_DIPOSIT_HEADER
            }

            console.log(depositObj)
            // axios.post('http://localhost:5009/deposit/updateChequeDeposits', depositObj)
            axios.post(window.accountServer + '/deposit/updateChequeDeposits', depositObj)
                .then(response => {
                    if (response.data.success) {
                        this.saveDeposit('DRAFT');
                    }


                }).catch(function (error) {
                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        } else {
            this.saveDeposit('DRAFT');
        }

    }


    onSubmit = (model) => {
        if (this.state.search_type == "CHEQUE") {
            if (newDateAr.length == 0) {
                this.props.alert.error("select cheque payments.");
            } else {
                if (this.state.isUpdate == true) {
                    const depositObj = {
                        ID_DIPOSIT_HEADER: this.state.ID_DIPOSIT_HEADER
                    }

                    console.log(depositObj)
                    // axios.post('http://localhost:5009/deposit/updateChequeDeposits', depositObj)
                    axios.post(window.accountServer + '/deposit/updateChequeDeposits', depositObj)
                        .then(response => {
                            if (response.data.success) {
                                this.saveDeposit('DONE');
                            }


                        }).catch(function (error) {
                            console.log("err " + error);
                            console.log("No internet connection or Internal error");
                            // alert("No internet connection or Internal error");
                        });
                } else {
                    this.saveDeposit('DONE');
                }

            }
        } else {
            this.saveDeposit('DONE');
        }
    };


    saveDeposit(status) {
        // alert("dd" + this.state.branch.value);
        // alert("dde" + this.state.account.value)
        var transactionLedgerDetails = [];
        var transactionLedgerHeader = {};

        var depositDetails = [];
        var depositHeader = {};
        for (let i = 0; i < newDateAr.length; i++) {
            var array = [
                newDateAr[i].cheque_date,
                newDateAr[i].cheque_no,
                newDateAr[i].bank,
                newDateAr[i].amount,
                true,
                true
            ]
            depositDetails.push(array)

        }


        depositHeader = {
            DATE: this.state.date,
            DOCUMENT_NO: this.state.doc_num,
            TRANSACTION_DATE: this.state.transaction_date,
            REFERENCE_NO: this.state.ref_no,
            ISSUED_BANK: this.state.bank.label,
            DEPOSIT_TYPE: this.state.search_type,
            DESCRIPTION: this.state.description,
            CASH_TOTAL_AMOUNT: this.state.total_cash_amount,
            CASH_PAYED_AMOUNT: this.state.cash_amount,
            DIPOSITED_BANK_ACCOUNT: this.state.deposited_bank.label,
            DEPOSIT_LEDGER_ID: this.state.deposited_bank.value,
            NUM_OF_CHEQUE: this.state.cheque_no,
            FROM_DATE: this.state.from_date,
            TO_DATE: this.state.to_date,
            STATUS: status,
            IS_ACTIVE: true
        }


        var dipositnObj = {
            depositHeader,
            depositDetails

        }

        console.log(dipositnObj)

        if (this.state.search_type == "CHEQUE") {
            transactionLedgerHeader = {
                TANSACTION_TYPE: "CHEQUE_DEPOSIT",
                DOCUMENT_NO: this.state.doc_num,
                IS_ACTIVE: 1,
                DATE: this.state.transaction_date,
            }

            for (let i = 0; i < newDateAr.length; i++) {
                var arrayS = [
                    this.state.deposited_bank.value,
                    4,
                    null,
                    null,
                    newDateAr[i].amount,
                    null,
                    null,
                    1,
                    null,
                ]
                transactionLedgerDetails.push(arrayS)
            }

            for (let i = 0; i < newDateAr.length; i++) {
                var arrayS = [
                    6,
                    2,
                    null,
                    newDateAr[i].amount,
                    null,
                    null,
                    null,
                    1,
                    null,
                ]
                transactionLedgerDetails.push(arrayS)
            }
        } else {
            transactionLedgerHeader = {
                TANSACTION_TYPE: "CASH_DEPOSIT",
                DOCUMENT_NO: this.state.doc_num,
                IS_ACTIVE: 1,
                DATE: this.state.transaction_date,
            }

            // for (let i = 0; i < newDateAr.length; i++) {
            var arrayS = [
                this.state.deposited_bank.value,
                4,
                null,
                null,
                this.state.cash_amount,
                null,
                null,
                1,
                null,
            ]
            transactionLedgerDetails.push(arrayS)
            // }

            // for (let i = 0; i < newDateAr.length; i++) {
            var arrayS = [
                6,
                1,
                null,
                this.state.cash_amount,
                null,
                null,
                null,
                1,
                null,
            ]
            transactionLedgerDetails.push(arrayS)
            // }
        }



        var transactionObj = {
            transactionLedgerHeader,
            transactionLedgerDetails

        }

        // axios.post('http://localhost:5009/transactionLedger/bulkInsert ', transactionObj)
        axios.post(window.accountServer + '/transactionLedger/bulkInsert ', transactionObj)
            .then(response => {
                console.log(response)
                if (response.data.success == true) {

                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });


        if (status == "DONE") {
            axios.post(window.accountServer + '/transactionLedger/bulkInsertDeposit ', dipositnObj)
                .then(res => {

                    if (res.data.success) {
                        this.clearValue();
                        this.loadData();
                        newDateAr = []
                        // this.loadBankLedger();
                        this.props.alert.success("bank deposit added successfully ");

                    } else {
                        // alert(res.data.message);
                        this.props.alert.error(res.data.message);
                    }
                })
            if (this.state.search_type == "CHEQUE") {
                this.getChequeReport(dipositnObj)
            } else {
                this.getCashReport(dipositnObj)
            }

        } else {

            // axios.post('http://localhost:5009/transactionLedger/bulkInsertDeposit ', dipositnObj)
            axios.post(window.accountServer + '/transactionLedger/bulkInsertDeposit ', dipositnObj)
                .then(res => {

                    if (res.data.success) {
                        this.clearValue();
                        this.loadData();
                        this.props.alert.success("bank deposit draft successfully ");

                    } else {
                        // alert(res.data.message);
                        this.props.alert.error(res.data.message);
                    }
                })
        }
        if (this.state.search_type == "CHEQUE") {
            // axios.post('http://localhost:5006/receipt/updateChequeReciptDeposit ', newDateAr)
            axios.post(window.salesServer + '/receipt/updateChequeReciptDeposit ', newDateAr)
                .then(res => {

                    if (res.data.success) {
                        this.clearValue();
                        this.loadData();
                    } else {
                        // alert(res.data.message);
                        this.props.alert.error(res.data.message);
                    }
                })
        }


    }
    getChequeReport(dipositnObj) {
        var address = null;
        // console.log("tttttttttttt"+JSON.stringify(dipositnObj) )
        // axios.post('http://localhost:2008/pettyCashReport/get/bankChequedeposit ', dipositnObj)
        axios.post(window.reportServer + '/pettyCashReport/get/bankChequedeposit ', dipositnObj)
            .then(res => {

                address = res.data.path;
                address = window.reportServer + "/" + address;
                // address = "http://localhost:2008/" + address;

                //alert(address)
                printjs({ printable: address, type: 'pdf', showModal: true })
            })
    }

    getCashReport(dipositnObj) {
        var address = null;
        // console.log("tttttttttttt"+JSON.stringify(dipositnObj) )
        // axios.post('http://localhost:2008/pettyCashReport/get/bankCashDeposit ', dipositnObj)
        axios.post(window.reportServer + '/pettyCashReport/get/bankCashDeposit ', dipositnObj)
            .then(res => {

                address = res.data.path;
                address = window.reportServer + "/" + address;
                // address = "http://localhost:2008/" + address;

                //alert(address)
                printjs({ printable: address, type: 'pdf', showModal: true })
            })
    }



    clearValue = () => {
        // alert()
        this.form.reset();
        this.setState({
            data: [],
            // banks: [],
            cheques: [],
            bank: '',
            deposited_bank: '',
            search_type: 'CHEQUE',
            doc_num: '',
            ref_no: '',
            description: '',
            cheque_no: '',
            total_cash_amount: '',
            date: moment(new Date()).format("YYYY-MM-DD"),
            transaction_date: moment(new Date()).format("YYYY-MM-DD"),
            from_date: moment(new Date()).format("YYYY-MM-DD"),
            to_date: moment(new Date()).format("YYYY-MM-DD"),
            cash_amount: ''
        });
    }


    chnageTypeValue = () => {
        this.form.reset();
        this.setState({
            data: [],
            // banks: [],
            cheques: [],
            bank: '',
            deposited_bank: '',
            // search_type: 'CHEQUE',
            doc_num: '',
            ref_no: '',
            description: '',
            cheque_no: '',
            total_cash_amount: '',
            date: moment(new Date()).format("YYYY-MM-DD"),
            transaction_date: moment(new Date()).format("YYYY-MM-DD"),
            from_date: moment(new Date()).format("YYYY-MM-DD"),
            to_date: moment(new Date()).format("YYYY-MM-DD"),
            cash_amount: ''
        });
    }

    componentWillMount() { }
    onSearchTypeChanged = (e) => {
        // alert(e.target.value)
        this.setState({
            search_type: e.target.value
        });
        if (e.target.value == 'CHEQUE') {
            this.setState({
                shown: true
            });
            this.chnageTypeValue()
        } else {
            this.setState({
                shown: false
            });
            this.chnageTypeValue()
            this.loadCashBookBalance()
        }
    }

    render() {
        const { classes } = this.props;

        var borderStyle = {
            'border-bottom': '4px solid darkgrey',
            'background-color': 'lightgrey',
            'border-style': 'inset'
        };

        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div className="pl-8">
                    <div className="subtitle-color p-8">
                        <h2>Bank Deposit</h2>
                    </div>
                    <Formsy
                        onValidSubmit={this.onSubmit}
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                        ref={(form) => this.form = form}
                        className="flex flex-col justify-center"
                    >
                        <fieldset style={borderStyle} className="bank-deposit-form-color  mt-8 mr-16  p-8 pb-16">

                            <div className="w-full md:w-2/3 search-margin">
                                {/* <div className="w-full md:w-1/3 mt-48"> */}
                                {/* <label> Gender </label> */}

                                <label className="md:w-1/3 ml-24 text-lg">
                                    <input onChange={this.onSearchTypeChanged} className="w-16 h-16" type="radio" name="searchType" value="CHEQUE" checked={this.state.search_type === 'CHEQUE'} /> Cheque</label>
                                <label className="md:w-1/3 ml-24 text-lg">
                                    <input onChange={this.onSearchTypeChanged} className="w-16 h-16" type="radio" name="searchType" value="CASH" checked={this.state.search_type === 'CASH'} /> Cash</label>

                                {/* <label className="md:w-1/3 ml-24 text-lg"><input onChange={(e) => this.onRadioChange('quatation')} className="w-16 h-16" type="radio" name="gender" value="quatation" checked={this.state.search_type === 'quatation'} />Quatation</label>
                                <label className="md:w-1/3 ml-24 text-lg"><input onChange={(e) => this.onRadioChange('invoice')} className="w-16 h-16" type="radio" name="gender" value="invoice" checked={this.state.search_type === 'invoice'} />Invoice</label> */}
                                {/* </div> */}
                            </div>

                            <div className="w-full block bank-deposit-form-size">
                                <div className="w-full sm:w-1/2 md:w-3/5 p-8 inline-block ">
                                    <div className="inline-block p-20">
                                        <div className="block" >Date</div>
                                        <TextFieldFormsy
                                            className="block"
                                            type="date"
                                            name='date'
                                            value={this.state.date}
                                            onChange={this.handleDate}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="inline-block p-20">
                                        <div className="block" >Document Number</div>
                                        <TextField
                                            className="block"
                                            name='doc_number'
                                            value={this.state.doc_num}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            onChange={this.handleDocNo}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="inline-block p-20">
                                        <div className="block" >Transaction Date *</div>
                                        <TextField
                                            className="block"
                                            name='transaction_date'
                                            type="date"
                                            value={this.state.transaction_date}
                                            onChange={this.handleTransactionDate}
                                            required
                                            //value={this.state.latePaymentMonthlyCharge}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>

                                    <div className="inline-block p-20">
                                        <div className="block" >Reference No.</div>
                                        <TextField
                                            className="block"
                                            name='ref_no'
                                            value={this.state.ref_no}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            onChange={this.handleRefNo}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>

                                    <div className="sm:w-1/2 md:w-1/5 inline-block p-20">
                                        <div className="block" >Description</div>
                                        <TextField
                                            className="block"
                                            name='description'
                                            value={this.state.description}
                                            //defaultValue={this.state.latePaymentMonthlyCharge}
                                            className={classes.textField}
                                            onChange={this.handleDescription}
                                            //margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="w-full sm:w-1/2 md:w-2/5 p-8 inline-block">

                                    {
                                        this.state.shown
                                            ?
                                            <div className="w-full sm:w-1/2 md:w-1/2 p-8 inline-block bank-deposit-table-margin ">
                                                Document Recall
                                                <ReactTable
                                                    className={classNames(classes.root, "-striped -highlight")}
                                                    getTrProps={(state, rowInfo, column) => {
                                                        return {
                                                            className: "cursor-pointer",
                                                            onClick: (e, handleOriginal) => {
                                                                if (rowInfo) {
                                                                    this.loadDraftDetails(rowInfo.original.id);
                                                                }
                                                            }
                                                        }
                                                    }}
                                                    data={this.state.draftList}
                                                    columns={[
                                                        {
                                                            Header: "Document No",
                                                            accessor: "draftCode",
                                                        },
                                                        {
                                                            Header: "Date",
                                                            accessor: "date",
                                                        },

                                                    ]}
                                                    defaultPageSize={2}
                                                    noDataText="No Drafts found"
                                                />
                                            </div>
                                            : null

                                    }

                                </div>
                            </div>
                            <Divider />
                            {
                                this.state.shown
                                    ?
                                    <div className="block mt-16">
                                        <div className="block" >
                                            <h3 className="bank-deposit-head-margin">Search By</h3>
                                        </div>

                                        <div className="w-full block">

                                            {/* <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                                <div className="block" >Cheque Issued bank *</div>
                                                <Select
                                                    className=""
                                                    name="form-field-name"
                                                    placeholder="Select Bank"
                                                    required
                                                    value={this.state.bank}
                                                    onChange={this.handleBank}
                                                    options={this.state.banks}
                                                />


                                            </div> */}
                                            <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                                <div className="block" >From Date *</div>
                                                <TextField
                                                    className="block"
                                                    id="start_num"
                                                    name='from_date'
                                                    type="date"
                                                    value={this.state.from_date}
                                                    onChange={this.handleFromDate}
                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                    required
                                                    className={classes.textField}
                                                    //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                                    //margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>

                                            <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                                <div className="block" >To Date *</div>
                                                <TextField
                                                    className="block"
                                                    id="start_num"
                                                    name='to_date'
                                                    type="date"
                                                    value={this.state.to_date}
                                                    onChange={this.handleToDate}
                                                    required
                                                    //defaultValue={this.state.latePaymentMonthlyCharge}
                                                    className={classes.textField}
                                                    //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                                    //margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>

                                            <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block ">
                                                <DialogActions className="justify-right pl-16 bank-deposit-btn-margins">


                                                    <Button
                                                        variant="raised"
                                                        color="secondary"
                                                        className="mx-16 mt-16 pb-15"
                                                        aria-label="Clear"
                                                        onClick={(e) => this.searchReciptData()}
                                                    //disabled={!canSubmit}
                                                    >
                                                        Search
                                                    </Button>

                                                </DialogActions>
                                            </div>
                                        </div>





                                    </div>
                                    :
                                    <div className="block mt-16">

                                        {/* <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                            Cash Book
                                         <Select
                                                className=""
                                                name="form-field-name"
                                                placeholder="Select Cash Book"

                                                value={this.state.account}
                                                onChange={this.handleAcount}
                                                options={this.state.accounts}
                                            />
                                        </div> */}
                                        <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                            <div className="block" >Total Cash Amount *</div>
                                            <TextField
                                                className="block"
                                                id="start_num"
                                                name='total_cash_amount'
                                                value={this.state.total_cash_amount}
                                                onChange={this.handleTotalCashAmount}
                                                //value={this.state.latePaymentMonthlyCharge}
                                                //defaultValue={this.state.latePaymentMonthlyCharge}
                                                className={classes.textField}
                                                required
                                                //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                                //margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>

                                        {/* <div className="block" >


                                            <Button
                                                variant="raised"
                                                color="secondary"
                                                className="mx-16 mt-16 pb-15"
                                                aria-label="Clear"
                                            //disabled={!canSubmit}
                                            >
                                                Search
                                            </Button>

                                        </div> */}

                                    </div>

                            }

                            <Divider className=" mt-16" />
                            {
                                this.state.shown
                                    ?

                                    <div>

                                        <ReactTable
                                            data={this.state.cheques}
                                            columns={[
                                                {
                                                    Header: "Cheque Date",
                                                    accessor: "cheque_date",
                                                    className: "justify-center",
                                                    width: 250

                                                },
                                                {
                                                    Header: "Cheque Number",
                                                    className: "justify-center",
                                                    accessor: "cheque_no",
                                                    width: 250
                                                },
                                                {
                                                    Header: 'Bank',
                                                    className: "justify-center",
                                                    accessor: "bank",
                                                    width: 250,

                                                },
                                                {
                                                    Header: "Amount",
                                                    className: "justify-center",
                                                    accessor: "amount",
                                                    width: 250
                                                },
                                                {
                                                    Header: "Select",
                                                    className: "justify-center",
                                                    accessor: "select_row",

                                                    Cell: row => (
                                                        <div align="center" className="w-full">
                                                            <Checkbox
                                                                // checked={false}
                                                                // className="abd"
                                                                id={"checkRecipt_" + row.original.id}
                                                                ref={'ref_' + row.original.id}
                                                                value="checkedA"
                                                                // disabled={row.original.dueAmountChange ? false : true}
                                                                checked={row.original.dueAmountCheck ? true : false}
                                                                onChange={(ev) => {
                                                                    this.handleCheckControlAccount(
                                                                        ev,
                                                                        row.original.row_id,
                                                                        row.original.id,
                                                                        row.original.cheque_date,
                                                                        row.original.cheque_no,
                                                                        row.original.bank,
                                                                        row.original.amount
                                                                    )
                                                                }}
                                                            />
                                                        </div>
                                                    ),
                                                },
                                            ]}
                                            defaultPageSize={5}
                                            className="-striped -highlight"
                                        />
                                        <br />
                                    </div>
                                    : null

                            }


                            <div className="block bank-deposit-final-margin ">
                                {
                                    this.state.shown
                                        ?
                                        <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                            <div className="block" >Number Of Cheque Count</div>
                                            <TextField
                                                className="block"
                                                disabled={true}
                                                name='no_of_cheques'
                                                value={this.state.cheque_no}

                                                //defaultValue={this.state.latePaymentMonthlyCharge}
                                                className={classes.textField}
                                            //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                            //margin="normal"

                                            />
                                        </div>
                                        : <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                            <div className="block" >Cash Amount *</div>
                                            <TextField
                                                className="block"
                                                // disabled={true}
                                                name='cash_amount'
                                                value={this.state.cash_amount}
                                                onChange={this.handleCashAmount}
                                                //defaultValue={this.state.latePaymentMonthlyCharge}
                                                className={classes.textField}
                                                required
                                            //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                            //margin="normal"

                                            />
                                        </div>

                                }

                            </div>

                            <div className="block bank-deposit-final-margin">

                                <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                    Deposited Ledger Account *
                                    <Select
                                        className=""
                                        name="form-field-name"
                                        placeholder="Select Bank"
                                        value={this.state.deposited_bank}
                                        onChange={this.handleDepositBank}
                                        options={this.state.bankLedgers}
                                        required
                                    />
                                </div>
                            </div>


                            <DialogActions className="justify-right pl-16 bank-deposit-btn-margins">
                                <Button
                                    variant="raised"
                                    color="secondary"
                                    className="mx-16 mt-16 pb-15"
                                    aria-label="Save"
                                    type="submit"
                                //disabled={!canSubmit}
                                >
                                    Save
                                </Button>
                                {
                                    this.state.shown
                                        ?
                                        <Button
                                            variant="raised"
                                            color="primary"
                                            className="mx-16 mt-16 pb-15"
                                            aria-label="Clear"
                                            //disabled={!canSubmit}
                                            onClick={(e) => this.addToDraft()}
                                        >
                                            Draft
                                        </Button>
                                        : null

                                }
                                <Button
                                    variant="raised"
                                    color="primary"
                                    className="mx-16 mt-16 pb-15"
                                    aria-label="Clear"
                                    //disabled={!canSubmit}
                                    onClick={this.clearValue}
                                >
                                    Clear
                                </Button>

                                <Button
                                    variant="raised"
                                    type="button"
                                    color="primary"
                                    className="mx-16 mt-16 pb-15"
                                    aria-label="Clear"


                                //disabled={!canSubmit}
                                >
                                    Help
                                </Button>

                            </DialogActions>



                        </fieldset>
                    </Formsy>


                </div>
            )


        }
    }



}

export default withStyles(styles, { withTheme: true })(withAlert(BankDeposit));


// WEBPACK FOOTER //
// ./src/main/content/accounting/bankDeposit/BankDeposit.js